import React from "react";
import Home from "./Home";
import StarRatings from "react-star-ratings";
import { Row, Col, Icon, CardTitle, Card } from "react-materialize";
import { CheckAuth, API_COURSE_BASE_URL, FormatPrice, QueryParam } from "../../Util";
import './Landingpage.css';
import $ from 'jquery';
import store from 'store';
import { Link } from 'react-router-dom';
import datadump from './coursedump.json'

class Course extends Home {
	constructor(props) {
		super(props);
		let params = QueryParam();
		this.state = { 
			kursus: [],
			max_title_length: 35,
			params: params
		};
	}

	componentDidMount() {
	  this.handleLoadData();
	}

	componentWillReceiveProps(props) {		
		let params = QueryParam();		
		this.setState({ params: params });
	}
	
	componentDidUpdate(prevProps){
		if(this.props.location.search !== prevProps.location.search){
			this.handleLoadData(QueryParam());
		}
	}

	handleLoadData = params => {
		if (!params) {
			params = this.state.params;
		}

		$.get(API_COURSE_BASE_URL, params)
		.then((data) => {
			//   let courseData = { kursus: datadump.data }; //dump data
		  let courseData = { kursus: data.payload };
		  store.set("course_data", courseData);

		  this.setState(courseData);
		});
		
	};

	renderTitle = (title) => {
		return title.length < this.state.max_title_length ? title : title.substring(0, this.state.max_title_length) + "..."
	}

	getKurses = () => {
		var course = (
		  this.state.kursus.map((item,index) => (
			  <Col key={item.uuid || index}
				l={3}
				m={3}
				s={12}
			  >
				<Card
				  header={<CardTitle image={item.thumbnail_small}></CardTitle>}
				  style={{borderRadius:'15px', height: '100%', minHeight: '400px', border: '0.8px solid #9cbf3f' }}
				>
				  <Link to={`/course/${item.slug}`}>
					  	<div className="content-desktop" style={{maxHeight:'42px', overflowY:'hidden', fontWeight:"bolder"}}>{ this.renderTitle(item.title) }</div>
					  	<div className="content-mobile" style={{fontWeight:"bolder"}}>{ item.title }</div> 
							{
								item.review.rating != 0 ?
								<div style={{ display:"flex" }}>
									<StarRatings
										rating={item.review.rating}
										starDimension={"1rem"}
										starRatedColor={"#f2c94c"}
										starSpacing={"1px"}
									/>
									<p style={{lineHeight: "1.4rem", paddingLeft:"5px", fontSize:"12", fontWeight:"bold"}}>{item.review.rating}</p>
								</div>
								:
									""
							}
						<div style={{ bottom: "0px", display:'flex', alignItems:'center', 'fontSize':"13px"}}>
							<img className="circle" style={{width:'30px', marginTop:'5px',marginBottom:'5px',marginRight:'4px'}} src={item.instructor_avatar} />
								{ item.instructor}
						</div>
				  		<div style={{bottom: "0px"}}>{ FormatPrice(item.final_price) }</div>
						<div style={{ bottom: "0px", backgroundColor: "#dddddd", width: "fit-content" }}> <h6 className="pad-xs">{ (item.course_method && item.course_method == 'spl') ? 'Kelas Mandiri':'Live Webinar' }</h6></div>
				  </Link>
				</Card>
			  </Col>          
		  ))
		)
		return course;
	}  

	render() {
        const sectionname = {
				display:'flex',
				justifyContent:'center',
				alignItems:'center',
				color: "#df2e2e",
				margin: "20px",
				padding: "20px",
				fontSize: "1.5em",
				fontWeight: "bold",
        };

		let announcement = this.state.announcement;
		let isLogin = CheckAuth() != "";
		let params = this.state.params;
		let addedTitle = params.t? ( params.t == 'spl'? 'Mandiri':'Webinar') : "";
		return (
			<div style={{position:'relative', overflow:'hidden'}}>
				<div style={{
					position:'absolute',
					top:'30%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							left:'25px',
							zIndex:3,
						}}
						src="/img/ornament/Banner-06.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'-3px',
							left:'-35px',
							zIndex:2,
						}}
						src="/img/ornament/strip-right.jpg" 
					/>
				</div>
				<div style={{
					position:'absolute',
					top:'55%',
					right:'15%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							zIndex:3,
						}}
						src="/img/ornament/Banner-09.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'4px',
							right:'-220px',
							zIndex:2,
						}}
						src="/img/ornament/strip-left.jpg" 
					/>
				</div>
				<div className="bg-white pad-xl fadeIn wow">		
					<div style={sectionname}>
						<img 
							style={{width:'30px'}}
							src="/img/ornament/Banner-12.png"
						/>	
						<h4 style={{marginBottom:0}}>Daftar Kelas {addedTitle}</h4>
						<img 
							style={{width:'30px'}}
							src="/img/ornament/Banner-13.png"
						/>      
					</div>
					<div className="container">
						{params.query && 
							<h5 className="mb-m">
								<span className="font-grey">
									Dengan Kata Kunci Pencarian :{" "}
								</span>
								{params.query}
							</h5> 
						}
						<Row>
							{this.getKurses()}
						</Row>
					</div>
				</div>
                                
			</div>
		);
	}
}


export default Course;



// WEBPACK FOOTER //
// ./src/components/Public/Home/Course.js